import { f as m } from "./index773.mjs";
import { i as v } from "./index778.mjs";
import { i as n } from "./index862.mjs";
import { g as l } from "./index873.mjs";
import { o as f } from "./index874.mjs";
import { w as s } from "./index760.mjs";
var d = m, e = v, a = n, b = l, c = f, y = s, w = TypeError, T = y("toPrimitive"), j = function(r, o) {
  if (!e(r) || a(r))
    return r;
  var t = b(r, T), i;
  if (t) {
    if (o === void 0 && (o = "default"), i = d(t, r, o), !e(i) || a(i))
      return i;
    throw new w("Can't convert object to primitive value");
  }
  return o === void 0 && (o = "number"), c(r, o);
};
export {
  j as t
};
